import * as yup from "yup";

export const WSIBCodeRateSetupValidationSchema = yup.object().shape({
  provinceId: yup.string().required("Province is required"),
  codeId: yup.string().required("Code is required"),
  rate: yup.string().required("Rate is required"),
  effectiveDate: yup.string().required("Effective Date is required"),
});
